export function normalizeSearchText(value: unknown): string {
  return String(value ?? '')
    .trim()
    .toLocaleLowerCase()
    .replace(/\s+/g, ' ');
}

export function normalizePhoneSearchValue(value: unknown): string {
  return String(value ?? '')
    .trim()
    .replace(/[^\d+]/g, '');
}

export function matchesTextSearch(value: unknown, searchTerm: unknown): boolean {
  const normalizedTerm = normalizeSearchText(searchTerm);
  return !normalizedTerm || normalizeSearchText(value).includes(normalizedTerm);
}

export function matchesPhoneSearch(value: unknown, searchTerm: unknown): boolean {
  if (!normalizeSearchText(searchTerm)) {
    return true;
  }

  const normalizedTerm = normalizePhoneSearchValue(searchTerm);
  if (!normalizedTerm) {
    return false;
  }

  return normalizePhoneSearchValue(value).includes(normalizedTerm);
}
